import "../assets/css/comingSoon.css";
import { Status } from "../constants/status";

export const ComingSoon = ({ headerName = "" }) => {
  return (
    <section id="comingSoon">
      <div className="coming-soon-container">
        {headerName && (
          <div>
            <h3>{headerName?.toUpperCase()}</h3>
            <hr />
          </div>
        )}
        {Status.getStatusValue(Status.COMINGSOON)}
      </div>
    </section>
  );
};
